import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';

/** Potency values (THC, CBD, TAC, TERPS). Renders nothing when no potency data exists. */
export function CardPotency(): JSX.Element | null {
  const { potency } = useCardContext();

  if (potency.length === 0) {
    return null;
  }

  return (
    <>
      {potency.map((p) => (
        <PotencyItem key={p}>{p}</PotencyItem>
      ))}
    </>
  );
}

const PotencyItem = styled.span`
  color: #646d72;
  font-family: ${({ theme }) => theme.customized.fonts.secondary};
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
`;
